import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Compare = () => (_jsxs("svg", Object.assign({ viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { d: "m43.74 2-4.09 3.81 10.14 10.24h-25.85l-.01 5.63h25.87l-9.8 9.94 3.9 4.04 16.71-16.94z" }), _jsx("path", { d: "m20.26 62 4.09-3.82-10.14-10.24h25.85l.01-5.63h-25.87l9.8-9.94-3.9-4.04-16.71 16.94z" })] })));
Compare.iconName = "compare";
Compare.iconCategory = "Misc - Deprecated";
Compare.deprecated = true;
export default Compare;
